import { useQuery } from '@apollo/client/react';

import { listQuery } from '../../services/AccountService';

export const useAccounts = (filter, { limit, offset }) => {
  const { data, loading, error } = useQuery(listQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { filter, limit, offset }
  });

  return { accounts: data?.accounts || [], loading, error };
};
